export default {"src":"/_next/static/media/icon_chat_header_dark.eb0ed4bd.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};